<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.app-loader {
  position: fixed;
  background: rgba(0,0,0,0.6);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
}
.app-loader::after {
  position: absolute;
  content: ' ';
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 80px;
  height: 80px;
  margin: -40px 0 0 -40px;
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #01579b;
  -webkit-animation: spin 1000ms linear infinite;
  animation: spin 1000ms linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} 
</style>


// WEBPACK FOOTER //
// src/App.vue